import { AFFECTED_LEVELS } from 'scenes/SmartRules/SmartRuleForm/constants';

// Fields
export const NETWORKS = 'networks';
export const PLATFORMS = 'platforms';
export const APPLICATIONS = 'applications';
export const AFFILIATES = 'affiliates';
export const OWNERS = 'owners';
export const LABELS = 'labels';
export const CAMPAIGNS = 'campaigns';
export const PARTNER_CAMPAIGNS = 'partnerCampaigns';
export const AD_SETS = 'adSets';
export const COUNTRIES = 'countries';
export const CHANNELS = 'channels';
export const MASTER_CAMPAIGNS = 'masterCampaigns';
export const SOCIAL_MEDIA_PLATFORMS = 'socialMediaPlatforms';
export const INFLUENCER_CAMPAIGNS = 'influencerCampaigns';
export const TRAFFIC_TYPE = 'trafficType';
export const TRAFFIC_TYPE_ADVERTISING = 1
export const FIELDS_BY_AFFECTED_LEVEL = {
  [AFFECTED_LEVELS.OFFER]: [COUNTRIES, LABELS, CAMPAIGNS],
  [AFFECTED_LEVELS.AFFILIATE]: [COUNTRIES, LABELS],
  [AFFECTED_LEVELS.APPLICATION]: [COUNTRIES, LABELS],
  [AFFECTED_LEVELS.CAMPAIGN]: [COUNTRIES, LABELS, CAMPAIGNS],
  [AFFECTED_LEVELS.PARTNER_CAMPAIGN]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
  ],
  [AFFECTED_LEVELS.AD_SET]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.AGGREGATED_PUBLISHER]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.PUBLISHER]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.AGGREGATED_PLACEMENT]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.PLACEMENT]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.PARTNER_AD]: [
    COUNTRIES,
    LABELS,
    CAMPAIGNS,
    PARTNER_CAMPAIGNS,
    AD_SETS,
  ],
  [AFFECTED_LEVELS.PLATFORM]: [COUNTRIES, LABELS],
  [AFFECTED_LEVELS.REAL_COUNTRY]: [CAMPAIGNS],
  [AFFECTED_LEVELS.INFLUENCER_CAMPAIGN]: [
    OWNERS,
    NETWORKS,
    APPLICATIONS,
    CHANNELS,
    AFFILIATES,
    MASTER_CAMPAIGNS,
    SOCIAL_MEDIA_PLATFORMS,
    INFLUENCER_CAMPAIGNS,
    COUNTRIES,
  ],
  [AFFECTED_LEVELS.CONCEPT]: [COUNTRIES, CAMPAIGNS],
  [AFFECTED_LEVELS.CREATIVE_FILE]: [COUNTRIES, CAMPAIGNS],
  [AFFECTED_LEVELS.TAG]: [COUNTRIES, CAMPAIGNS],
  [AFFECTED_LEVELS.TRAFFIC_TYPE]: [
    OWNERS,
    NETWORKS,
    PLATFORMS,
    APPLICATIONS,
    CHANNELS,
    AFFILIATES,
    LABELS,
    COUNTRIES,
  ],
};
